import { FormProvider } from 'react-hook-form';
import {
  BankType,
  OfferCodeInputLabels,
  OfferCodeInputVariables,
} from '@sparrow-card/sparrow-card-constants';
import focusCreditCardImage from 'assets/images/double-credit-card-focus.webp';
import creditCardImage from 'assets/images/double-credit-card.webp';
import Button from 'components/Button';
import { ButtonVariant } from 'components/Button/Button';
import {
  OFFER_CODE_MAIL_OFFER_TOOLTIP,
  OfferCodeInput,
  STANDARD_OFFER_CODE_MASK_OPTIONS,
  STANDARD_OFFER_CODE_PLACEHOLDER,
  ZIP_CODE_PLACEHOLDER,
  ZIP_MASK_OPTIONS,
  ZipInput,
} from 'components/Input/templates';
import ValidationError from 'components/ValidationError';
import useDmBankPartner from 'hooks/useDmBankPartner';
import OfferCodeLayout from 'layout/OfferCodeLayout';
import useDirectMailOfferForm from 'pages/OfferCode/DirectMailOfferCode/useDirectMailOfferForm';
import { OFFER_CODE_ZIP_RULES } from 'pages/OfferCode/offerCodeZipRules';
import styles from 'pages/OfferCode/OfferCode.module.scss';

const LAYOUT_TITLE = 'Get Your Sparrow Rewards Mastercard®';
const LAYOUT_DESCRIPTION =
  'To get started, please enter your Offer Code from the Pre-Approved offer you received.';

const INPUTS_TO_MASKS_MAPPING = {
  [OfferCodeInputVariables.OfferCode]: STANDARD_OFFER_CODE_MASK_OPTIONS,
  [OfferCodeInputVariables.ZipCode]: ZIP_MASK_OPTIONS,
};

const DirectMailOfferCode = () => {
  const { error, isLoading, isFormFilled, ...methods } =
    useDirectMailOfferForm(INPUTS_TO_MASKS_MAPPING);
  const bankPartner = useDmBankPartner();
  const previewImagePath = bankPartner === BankType.Focus ? focusCreditCardImage : creditCardImage;

  const { onSubmit, clearErrors } = methods;

  return (
    <OfferCodeLayout
      description={LAYOUT_DESCRIPTION}
      title={LAYOUT_TITLE}
      previewImagePath={previewImagePath}
    >
      <FormProvider {...methods}>
        <form onSubmit={onSubmit} id="offer-code-form" noValidate>
          <div className={styles.inputsContainer}>
            <OfferCodeInput
              name={OfferCodeInputVariables.OfferCode}
              label={OfferCodeInputLabels.OfferCode}
              required
              placeholder={STANDARD_OFFER_CODE_PLACEHOLDER}
              maskOptions={STANDARD_OFFER_CODE_MASK_OPTIONS}
              containerClassName={styles.input}
              inputMode="numeric"
              tooltipText={OFFER_CODE_MAIL_OFFER_TOOLTIP}
            />
            <ZipInput
              name={OfferCodeInputVariables.ZipCode}
              label={OfferCodeInputLabels.ZipCode}
              required
              placeholder={ZIP_CODE_PLACEHOLDER}
              rules={OFFER_CODE_ZIP_RULES}
              externalOnChange={() => {
                clearErrors(OfferCodeInputVariables.ZipCode);
              }}
              containerClassName={styles.input}
            />
          </div>
          {!!error && (
            <ValidationError
              message={error}
              className={styles.offerCodeError}
              role="alert"
              aria-live="assertive"
            />
          )}
          <Button
            type="submit"
            title="Get started"
            variant={ButtonVariant.Gradient}
            className={styles.button}
            inactive={!isFormFilled}
            loading={isLoading}
          />
        </form>
      </FormProvider>
    </OfferCodeLayout>
  );
};

export default DirectMailOfferCode;
